module.exports = __webpack_public_path__ + "static/media/my-kpi.422e9e55.svg";